import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ImpressionContext from './ImpressionContext';
import useImpression from './useImpression';
/**
 * Unlike in react-native environments, there are ways for elements to identify
 * for themselves if they're visible in the viewport. This component is a simple
 * wrapper that uses `IntersectionObserver` to set the `isVisible` prop.
 *
 * By default, it wraps its children in a `<div>` and uses that to determine
 * visibility. A different wrapping component can be specified with the
 * `component` prop.
 */

var Impression = function Impression(_ref) {
  var children = _ref.children,
      Component = _ref.component,
      elementName = _ref.elementName,
      entityName = _ref.entityName,
      enabled = _ref.enabled,
      eventType = _ref.eventType,
      payload = _ref.payload,
      refireOnEventChange = _ref.refireOnEventChange,
      rest = _objectWithoutProperties(_ref, ["children", "component", "elementName", "entityName", "enabled", "eventType", "payload", "refireOnEventChange"]);

  if (enabled) {
    // eslint-disable-next-line react-hooks/rules-of-hooks -- directive added automatically by Shepherd migration
    var _useImpression = useImpression({
      eventType: eventType,
      elementName: elementName,
      entityName: entityName,
      payload: payload,
      refireOnEventChange: refireOnEventChange
    }),
        ref = _useImpression.ref,
        impression = _objectWithoutProperties(_useImpression, ["ref"]);

    return React.createElement(ImpressionContext.Provider, {
      value: impression
    }, React.createElement(Component, _extends({
      ref: ref
    }, rest), children));
  }

  return React.createElement(Fragment, null, children);
};

Impression.propTypes = {
  children: PropTypes.node,

  /**
   * The component that will be used to measure visibility. It's important
   * that this component can get a ref to some underlying DOM node. See
   * https://reactjs.org/docs/forwarding-refs.html for more details on how
   * to do this with custom components.
   */
  component: PropTypes.elementType,

  /**
   * The name of the entity being tracked; maps to `entity_name` in the
   * resulting event.
   */
  entityName: PropTypes.string.isRequired,

  /**
   * A flag indicating if the component should be triggering events.
   * This will be used for now as instrumentation just started and
   * will be removed at a later time.
   */
  enabled: PropTypes.bool,

  /**
   * The type of event to track; defaults to `element_impression`.
   */
  eventType: PropTypes.string,

  /**
   * Additional data to be added to the event's payload. Will be combined with
   * the `elementName` prop and a generated `impression_id`. If `element_name`
   * or `impression_id` are present in this prop, their values will take
   * precedence over their respective prop or generated value.
   */
  payload: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /**
   * By default, events will be refired when the event payload changes. This
   * prop allows that behavior to be turned off.
   */
  refireOnEventChange: PropTypes.bool,

  /**
   * (Deprecated) The name of the element being tracked; maps to `element_name` in the
   * resulting event. Use `entityName` instead.
   */
  elementName: PropTypes.string
};
Impression.defaultProps = {
  children: null,
  component: 'div',
  enabled: true,
  eventType: 'element_impression',
  payload: null,
  refireOnEventChange: true
};
export default Impression;